import { createSlice } from '@reduxjs/toolkit'

const initialState = [
    {
        id: 1,
        name: 'New Candidate',
        slug: "new_candidate"
    },
    {
        id: 2,
        name: 'Screening',
        slug: "screening"
    },
    {
        id: 3,
        name: 'Shortlist',
        slug: "shortlisted"
    },
    {
        id: 4,
        name: 'Interview 1 Round Scheduled',
        slug: "interview_1_round_scheduled"
    },
    {
        id: 5,
        name: 'Interview 1 Round Completed',
        slug: "interview_1_round_completed"
    },
    {
        id: 6,
        name: 'Interview 2 Round Scheduled',
        slug: "interview_2_round_scheduled"
    },
    {
        id: 7,
        name: 'Interview 2 Round Completed',
        slug: "interview_2_round_completed"
    },
    {
        id: 8,
        name: 'Interview Hr Round Scheduled',
        slug: "interview_hr_round_scheduled"
    },
    {
        id: 9,
        name: 'Interview Final Round Scheduled',
        slug: "interview_final_round_scheduled"
    },
    {
        id: 10,
        name: 'Interview Final Round Completed',
        slug: "interview_final_round_completed"
    },
    {
        id: 11,
        name: 'Offer Sent',
        slug: "offer_sent"
    },
    {
        id: 12,
        name: 'Hired',
        slug: "hired"
    },

]

const interviewStagesSlice = createSlice({
    name: 'interview/stages',
    initialState,
    reducers: {

    },
});

export default interviewStagesSlice.reducer